<template>
  <div>
    <Button
      @click="toggleDrawer"
      icon="icon icon-hamburger"
      new-design
      size="large"
      type="primary"
      plain
    >
      {{ $t('navigation.toggle.menu') }}
    </Button>

    <Drawer
      :visible.sync="isOpen"
      :append-to-body="true"
      :show-close="false"
      size="min(100vw, 400px)"
    >
      <template slot="title">
        <div class="drawer__header">
          <CreateInvoiceButton @handle-click="toggleDrawer" />

          <Button
            @click="toggleDrawer"
            icon="icon icon-cross"
            new-design
            size="large"
            type="primary"
            plain
          >
            {{ $t('navigation.toggle.close') }}
          </Button>
        </div>
      </template>

      <div
        class="drawer__content"
      >
        <template v-if="!isMenuUserOpen">
          <div
            v-if="!isAuthorized"
            class="drawer__item"
          >
            <span
              class="drawer__text"
              v-html="$t('navigation.freeInvoiceCreate_html')"
            />
          </div>
          <div
            v-if="!isAuthorized"
            class="drawer__item"
          >
            <LoginButton @click.native="toggleDrawer" />
          </div>

          <NavigationLinks
            :show-in-drawer="true"
            @handle-drawer-toggle="toggleDrawer"
            @handle-user-menu-click="isMenuUserOpen=!isMenuUserOpen"
          />

          <SubNavigation />
        </template>

        <template v-else>
          <div class="drawer__item drawer__item--align-center">
            <Button
              class="back-button"
              @click="isMenuUserOpen=!isMenuUserOpen"
              icon="icon icon-chevron-left"
              type="icon"
            />

            <span class="text-with-icon icon icon-user-line">
              {{ $t('header.myAccount') }}
            </span>
          </div>
          <DropdownUserMenu
            :show-in-drawer="true"
            @handle-drawer-toggle="toggleDrawer"
            @handle-logout-click="toggleDrawer"
          />
        </template>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateInvoiceButton from '../header/CreateInvoiceButton.vue';
import DropdownUserMenu from '../header/DropdownUserMenu.vue';
import LoginButton from '../header/LoginButton.vue';
import NavigationLinks from './NavigationLinks.vue';
import SubNavigation from './SubNavigation.vue';

export default {
  components: {
    CreateInvoiceButton,
    DropdownUserMenu,
    LoginButton,
    NavigationLinks,
    SubNavigation,
  },
  data: () => ({
    isOpen: false,
    isMenuUserOpen: false,
  }),
  computed: {
    ...mapGetters('auth', [
      'isAuthorized',
    ]),
  },
  methods: {
    toggleDrawer() {
      this.isOpen = !this.isOpen;
      if (this.isMenuUserOpen) {
        this.isMenuUserOpen = !this.isMenuUserOpen;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer__header {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.drawer__content {
  padding: 12px 16px;
  width: 100%;
  list-style: none;
}

.drawer__item {
  padding: 12px 8px;
  border-bottom: 1px solid $--border-color-base;

  &:first-child {
    padding-top: 0;
  }
}

.drawer__item--align-center {
  display: flex;
  align-items: center;
  gap: 16px;
}

.drawer__text {
  display: block;
  color: $--color-text-blue;
  font-size: rem(16px);
  font-weight: 600;
  text-align: center;
}

.back-button {
  :deep() {
    .icon {
      padding: 0 5px;
      font-size: 24px;
    }
  }
}

.text-with-icon {
  display: inline-flex;
  align-items: center;
  color: $--color-primary-dark-3;
  font-size: rem(16px);
  font-weight: 600;

  &::before {
    font-size: 24px;
    font-weight: 400;
    margin-right: 12px;
  }
}
</style>
